module.exports = __webpack_public_path__ + "static/media/Band_Sight_Reading_Rubric.a965a5a7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Band_Sight_Reading_Rubric.pdf
// module id = 225
// module chunks = 0